import Vue from "vue";
import CXMApiClient from "../../CXMApiClient";
import moment from "moment";

const state = {
  ScheduleCalendarEventModal: {
    ShowModal: false,
    ContactId: null,
    PlatformId: null,
    ContactName: null,
    EventType: 0, // To pre-select an appointment type on load
    TouchpointId: 0, // To pre-select Showroom Visit / Delivery Visit
    Config: null // To customize the options available
  },
  ContactCalendarEvents: [],
  ShownStatusModalInfo: {
    Show: false,
    EventInfo: null
  },
  ConfirmationStatusModalInfo: {
    Show: false,
    EventInfo: null
  },
  CancelEventConfirmationModalInfo: {
    Show: false,
    EventId: null,
    Type: null
  }
};

const getters = {
  ShownStatusModalInfo: state => state.ShownStatusModalInfo,
  ConfirmationStatusModalInfo: state => state.ConfirmationStatusModalInfo,
  CancelEventConfirmationModalInfo: state =>
    state.CancelEventConfirmationModalInfo
};

const actions = {
  openScheduleCalendarEventModal(context, data) {
    context.commit("openScheduleCalendarEventModal", data);
  },
  closeScheduleCalendarEventModal(context) {
    context.commit("closeScheduleCalendarEventModal");
  },
  async scheduleCalendarEventForContact(context, requestPayload) {
    return await Vue.http.post("/pando/calendarevent", requestPayload).catch(err => err.response);
  },
  updateShownStatus: async function (context, request) {
    return await Vue.http
      .put(
        `/pando/calendarevent/${request.EventId}/update_show_status/${request.ShownStatusId}`
      )
      .catch(err => err.response);
  },
  deleteEvent(context, eventId) {
    return new Promise((resolve, reject) => {
      Vue.http
        .delete("pando/calendarevent/" + encodeURIComponent(eventId))
        .then(resp => {
          resolve(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  getCalendarEventsForContact(context, contact) {
    const now = moment();
    let payload = {
      AccountId: contact.accountId,
      PlatformIds: [contact.accountPlatformId],
      ContactId: contact.id,
      //UserIds: hasViewAllPermission ? [] : [userId],
      Start: contact.startDate ? moment(contact.startDate).startOf("day") : moment(now).startOf("day"),
      End: moment(now)
        .endOf("day")
        .add(1, "year"),
      From: 0,
      Size: 100
    };

    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/calendarevent/startvisit_summarysearch", payload)
        .then(resp => {
          if (resp && resp.data && resp.data.Data) {
            context.commit("gotCalendarEventsForContact", resp.data.Data);
            resolve(resp.data.Data);
          } else throw new Error("Unknown response format");
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  async deleteCalendarEvent(context, eventId) {
    return await Vue.http.delete("pando/calendarevent/" + encodeURIComponent(eventId)).catch(err => err.response);
  },
  updateConfirmationStatus: async function (context, request) {
    return await Vue.http[`${request.Method ? 'put' : 'post'}`](
      `/pando/calendarevent/${request.EventId}/${request.Path}`,
      request.Payload
    )
      .catch(err => err.response);
  },
  updateShownStatusModalInfo: function (context, data) {
    context.commit("updateShownStatusModalInfo", data);
  },
  updateConfirmationStatusModalInfo: function (context, data) {
    context.commit("updateConfirmationStatusModalInfo", data);
  },
  updateCancelEventConfirmationModalInfo: function (context, data) {
    context.commit("updateCancelEventConfirmationModalInfo", data);
  }
};

const mutations = {
  openScheduleCalendarEventModal(state, data) {
    state.ScheduleCalendarEventModal.ContactId = data.ContactId;
    state.ScheduleCalendarEventModal.PlatformId = data.PlatformId;
    state.ScheduleCalendarEventModal.ContactName = data.ContactName;
    state.ScheduleCalendarEventModal.EventType = data.EventType || 0;
    state.ScheduleCalendarEventModal.TouchpointId = data.TouchpointId || 0;
    state.ScheduleCalendarEventModal.Config = data.Config || null;
    state.ScheduleCalendarEventModal.ShowModal = true;
  },
  closeScheduleCalendarEventModal(state) {
    state.ScheduleCalendarEventModal.ContactId = null;
    state.ScheduleCalendarEventModal.PlatformId = null;
    state.ScheduleCalendarEventModal.ContactName = null;
    state.ScheduleCalendarEventModal.EventType = 0;
    state.ScheduleCalendarEventModal.TouchpointId = 0;
    state.ScheduleCalendarEventModal.Config = null;
    state.ScheduleCalendarEventModal.ShowModal = false;
  },
  gotCalendarEventsForContact(state, data) {
    state.ContactCalendarEvents = data || [];
  },

  updateConfirmationStatusModalInfo(state, data) {
    state.ConfirmationStatusModalInfo = data;
  },

  updateCancelEventConfirmationModalInfo(state, data) {
    state.CancelEventConfirmationModalInfo = data;
  },
  updateShownStatusModalInfo(state, data) {
    state.ShownStatusModalInfo = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/CalendarEvents.js